module.exports = __webpack_public_path__ + "img/index-zt2.86944c17.png";